module.exports = __webpack_public_path__ + "img/guest-user.e2b7a61c.svg";